Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.exampleAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "PasswordStrength";
exports.labelBodyText = "PasswordStrength Body";

exports.btnExampleTitle = "CLICK ME";
exports.secretKey = "SECRET KEY"
// Customizable Area End